export const locales = {
    /**
     * Default locale (en)
     */
    en: {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },

    /**
     * Merge locales
     * @param obj
     */
    merge(obj = {}) {
        Object.assign(this, obj);
    },

    /**
     * Set a language
     * @param name
     * @param object
     */
    set(name, object) {
        this[name] = object;
    },

    /**
     * Get a language
     * @param name
     * @returns {*}
     */
    get(name) {
        return this[name];
    }
};

export const formats = {
    /**
     * Default format
     */
    default: 'DD-MM-YY',

    /**
     * Title format
     */
    title_format: 'B Y',

    /**
     * Merge date formats
     * @param obj
     */
    merge(obj = {}) {
        Object.assign(this, obj);
    },

    /**
     * Set a date format
     * @param name
     * @param value
     */
    set(name, value) {
        this[name] = value;
    },

    /**
     * Get a date format
     * @param name
     * @returns {*}
     */
    get(name) {
        return this[name];
    }
};